export const POPOVER_ACTIONS = ['toggle', 'show', 'hide'] as const;

export type PopoverAction = (typeof POPOVER_ACTIONS)[number];

export const isPopoverAction = (value: unknown): value is PopoverAction =>
  POPOVER_ACTIONS.some((action) => action === value);
